import type { ExtractedSession, SessionStorageMode, SessionToken } from './types';

// Only an explicit `local` opts in; anything else — absent, `session`, or a
// typo — keeps the per-tab default. A malformed embed URL must not silently
// start persisting tokens on a shared browser profile.
function parseStorageMode(raw: string | null): SessionStorageMode {
  return raw === 'local' ? 'local' : 'session';
}

export function extractSessionFromURL(url: string): ExtractedSession {
  const params = new URL(url).searchParams;
  const rawToken = params.get('session_token');
  const rawGameId = params.get('game_id');
  const rawEmbedKey = params.get('embed_key');
  return {
    token: rawToken ? (rawToken as SessionToken) : null,
    gameId: rawGameId ? rawGameId : null,
    embedKey: rawEmbedKey ? rawEmbedKey : null,
    storageMode: parseStorageMode(params.get('session_storage')),
  };
}
